import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { BarChart3 } from "lucide-react";
import StatsTrendChart from "@/components/StatsTrendChart";

const thisMonth = () => new Date().toISOString().slice(0, 7);

// Self-serve monthly stats for Vendors, Event Creators and Marketplace users.
export default function YourStatsCard() {
  const { user } = useAuth();
  const [month, setMonth] = useState(thisMonth());
  const [data, setData] = useState(null);
  const keys = user?.role === "event_creator" ? ["clicks", "interests", "rsvps"] : ["clicks", "likes"];
  const labels = { clicks: "Clicks", likes: "Likes", interests: "Interests", rsvps: "RSVPs" };

  useEffect(() => {
    api.get("/my/analytics", { params: { month } }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [month]);

  return (
    <section className="mb-8 bg-white/80 border border-sage/20 rounded-3xl p-5 sm:p-6 shadow-sm" data-testid="your-stats-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h2 className="font-heading font-bold text-forest text-lg flex items-center gap-2"><BarChart3 className="w-5 h-5 text-sage-dark" /> Your stats</h2>
        <Input type="month" value={month} max={thisMonth()} onChange={(e) => e.target.value && setMonth(e.target.value)}
          className="rounded-xl bg-white w-44" data-testid="your-stats-month-input" />
      </div>
      <div className={`grid gap-3 mb-4 ${keys.length === 3 ? "grid-cols-3" : "grid-cols-2"}`}>
        {keys.map((k) => (
          <div key={k} className="bg-softstone/60 rounded-2xl p-4" data-testid={`your-stats-${k}`}>
            <div className="text-2xl font-black text-forest">{data ? data.stats[k] : "–"}</div>
            <div className="text-xs font-semibold text-forest/60">{labels[k]}</div>
          </div>
        ))}
      </div>
      {data && <StatsTrendChart data={data.trend} keys={keys} height={180} testid="your-stats-chart" />}
    </section>
  );
}
